import React, { useState } from 'react';
import './merchant-settings.scss';

import { Collapsible, LoadingOverlay } from '../../components';

import { Account, CallToAction, RequestProduct, Subscription } from '../organisms';
import { useTemplate } from '../useMerchantSettings';

const sections = {
  CTA: 'cta',
  ACCOUNT: 'account',
  SUBSCRIPTION: 'subscription',
  REQUEST_PRODUCT: 'request-product',
}

export function MerchantSettingsTemplate() {
  const { submitting } = useTemplate();
  const [open, setOpen] = useState({
    [sections.CTA]: false,
    [sections.ACCOUNT]: true ,
    [sections.SUBSCRIPTION]: false ,
    [sections.REQUEST_PRODUCT]: false,
  });;

  const toggleCollapsible = (section) => {
    setOpen({
      ...open,
      [section]: !open[section],
    });
  };

  return (
    <div className="page-wrapper">
      {submitting && <LoadingOverlay />}

      <Collapsible
        trigger="CALL TO ACTION"
        handleTriggerClick={() => toggleCollapsible(sections.CTA)}
        open={open[sections.CTA]}
        noContainer
      >
        <CallToAction />
      </Collapsible>

      <Collapsible
        trigger="ACCOUNT DETAILS"
        handleTriggerClick={() => toggleCollapsible(sections.ACCOUNT)}
        open={open[sections.ACCOUNT]}
        noContainer
      >
        <Account />
      </Collapsible>

      <Collapsible
        trigger="MANAGE SUBSCRIPTION"
        handleTriggerClick={() => toggleCollapsible(sections.SUBSCRIPTION)}
        open={open[sections.SUBSCRIPTION]}
        noContainer
      >
        <Subscription />
      </Collapsible>

      <Collapsible
        trigger="REQUEST NEW PRODUCT ADDITION TO LIBRARY"
        handleTriggerClick={() => toggleCollapsible(sections.REQUEST_PRODUCT)}
        open={open[sections.REQUEST_PRODUCT]}
        noContainer
      >
        <RequestProduct />
      </Collapsible>
    </div>
  );
}
